<template>
  <div class="container-grid grid-2 grid-md-1 mb-5">
    <div
        v-for="person in people"
        :key="person.name"
        class="container-grid__item"
    >
      <div class="container-shadow fill-white p-24">
        <div class="lead">
          <div class="lead__content content_18">
            <div class="content_subtitle content_700 mb-24">
              {{ person.name }}
            </div>
            <div class="lead__content-item mb-16">
              <div class="content_blue_light">Образование / Квалификация</div>
              <div class="lead__content-data">{{ person.education }}</div>
            </div>
            <div class="lead__content-item mb-16">
              <div class="content_blue_light">Учёная степень</div>
              <div class="lead__content-data">{{ person.degree || '-' }}</div>
            </div>
            <div class="lead__content-item mb-16">
              <div class="content_blue_light">Учёное звание</div>
              <div class="lead__content-data">{{ person.rank || '-' }}</div>
            </div>
            <div class="lead__content-item mb-16">
              <div class="content_blue_light">Повышение квалификации</div>
              <div class="lead__content-data" v-html="person.upgrade || '-'" />
            </div>
            <div class="lead__content-item mb-16">
              <div class="content_blue_light">Профессиональная переподготовка</div>
              <div class="lead__content-data" v-html="person.retraining || '-'" />
            </div>
            <div class="lead__content-item">
              <div class="content_blue_light">Стаж</div>
              <div class="lead__content-data">{{ person.experience || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualificationGrid",
  data() {
    return {
      people: [
        {
          name: "Дьяченко Олег Георгиевич",
          education: "Высшее, химик",
          degree: "Кандидат химических наук",
          rank: "-",
          upgrade: "-",
          retraining: "-",
          experience: "20 лет"
        },
        {
          name: "Лопатникова Элина Вячеславовна",
          education: "Высшее, финансовый менеджмент",
          degree: "-",
          rank: "-",
          upgrade: "-",
          retraining: "-",
          experience: "29 лет"
        },
        {
          name: "Мирумян Татьяна Викторовна",
          education: "Высшее, экономист",
          degree: "-",
          rank: "-",
          upgrade: "-",
          retraining: "-",
          experience: "40 лет"
        },
        {
          name: "Попова Елена Владимировна",
          education:
              "Высшее, учитель истории и обществоведения, специалист таможенного дела",
          degree: "-",
          rank: "-",
          upgrade:
              "«Таможенные аспекты внешней торговли товарами в России в современных условиях: актуальные вопросы и практика»",
          retraining:
              "«Трансграничная торговля и логистика, таможня: современные тренды и технологии» (Менеджмент)",
          experience: "28 лет"
        },
        {
          name: "Роскошная Мария Станиславовна",
          education: "Высшее, экономист (Мировая экономика)",
          degree: "-",
          rank: "-",
          upgrade:
              "«Экспортный контроль»<br>«Санкционная политика в современном мире»",
          retraining: "-",
          experience: "13 лет"
        },
        {
          name: "Титова Елена Павловна",
          education: "Высшее, инженер-теплоэнергетик; МВА «Стратегический менеджмент», Международный аудитор ISO",
          degree: "-",
          rank: "-",
          upgrade: "международная сертификация",
          retraining: "-",
          experience: "10 лет"
        },
        {
          name: "Кочемасова Анна Вячеславовна",
          education: "Высшее, экономист со знанием иностранного языка, MSGSCM",
          degree: "Кандидат экономических наук",
          rank: "Доцент",
          upgrade:
              "«Продуктовый менеджер. Практик», \n" +
              "«Валютные платежи и валютный контроль в современных условиях», \n" +
              "«ВЭД 2023: адаптация к последним изменениям», \n" +
              "«Дизайн мышление», \n" +
              "«Коуч как профессия 21 века» \n",
          retraining: "-",
          experience: "31 год"
        },
        {
          name: "Хохлов Антон Владимирович",
          education: "Высшее, географ",
          degree: "Кандидат географических наук",
          rank: "-",
          upgrade: "-",
          retraining: "-",
          experience: "-"
        },
        {
          name: "Кодыков Андрей Александрович",
          education: "Высшее, инженер-теплоэнергетик; МВА «Стратегический менеджмент», Международный аудитор ISO",
          degree: "-",
          rank: "-",
          upgrade: "-",
          retraining: "-",
          experience: "10 лет, международная сертификация"
        }
      ]
    };
  }
};
</script>
